import { CommonModule } from '@angular/common'
import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
// import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'
import { Subject, take } from 'rxjs'
import { inject } from '@angular/core'
import { AlertService } from '../../services/alert.service'
import { AlertData } from '../../models/alert.model'
import { AlertComponent } from './alert.component'

@Component({
    selector: 'restricted-product-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule, CommonModule]
})
export class SnackBarAlertComponent extends AlertComponent implements OnDestroy {
  /** Data to the snack bar is injected */
  override data = inject<AlertData>(MAT_SNACK_BAR_DATA)

  alertService = inject(AlertService)
  close$ = new Subject<void>()
  destroy$ = new Subject<void>()

  /* istanbul ignore next */
  constructor() {
    super()
    this.close$.pipe(take(1)).subscribe(() => {
      this.alertService.closeAlert()
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
